import type { CSVColumn } from "../../../utils/csvExport";
import { sanitizeUserInput } from "../../../utils/csvExport";

export type ExportableAccount = {
  id: string;
  name: string;
  classification: string;
  status: string;
  companyId: string | null;
  memberCount: number;
  entitlementCount: number;
};

export const TRUNCATION_NOTICE =
  "INCOMPLETE: results were truncated. This export does not include every affected account.";

export const EXPORT_COLUMNS: CSVColumn<ExportableAccount>[] = [
  { header: "Name", getValue: account => sanitizeUserInput(account.name) },
  { header: "Classification", getValue: account => account.classification },
  { header: "Status", getValue: account => account.status },
  { header: "Company ID", getValue: account => account.companyId ?? "" },
  { header: "Affected Users", getValue: account => account.memberCount },
  { header: "Live Entitlements", getValue: account => account.entitlementCount },
];

function buildTruncationNoticeRow(): ExportableAccount {
  return {
    id: "",
    name: TRUNCATION_NOTICE,
    classification: "",
    status: "",
    companyId: null,
    memberCount: 0,
    entitlementCount: 0,
  };
}

export function buildExportRows(
  accounts: ExportableAccount[],
  options: { truncated?: boolean } = {},
): ExportableAccount[] {
  if (accounts.length === 0) return [];
  if (options.truncated) return [buildTruncationNoticeRow(), ...accounts];
  return accounts;
}
